module.exports = __webpack_public_path__ + "img/reactions-laughing.bbd2b94a.svg";